import React, { useEffect, useState } from 'react';
import { get_driver_details, add_driver, save_supplier_driver, get_supplier_details, delete_driver, getAllCars } from '../api';
import Header from './MainHeader/Header';
import Loading from './Loading/Loading';

const DriverList = () => {
  const [supplierDrivers, setSupplierDrivers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [message, setMessage] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editDriverId, setEditDriverId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const token = user?.token;
  const supplierId = user?.driver_id;
  const [agreed, setAgreed] = useState(false);
  const [loginAccess, setLoginAccess] = useState(false);
  const [quotationProcess, setQuotationProcess] = useState(false);
  const [assignJourneyProcess, setAssignJourneyProcess] = useState(false);
  const [error, setError] = useState("");


  const [formData, setFormData] = useState({
    supplier_id: supplierId || '',
    email: '',
    first_name: '',
    last_name: '',
    country_code: '44',
    mobile_number: '0',
    vehicle: '',
    car_reg: '',
    make: '',
    vehicle_colour: '',
    member_type: 'subs',
    title: '',
    password: '',
  });

  useEffect(() => {
    const fetchDriverData = async () => {
      try {
        const response = await get_driver_details(supplierId, token);
        if (response.data?.supplier_driver_names) {
          setSupplierDrivers(response.data.supplier_driver_names);
          setMessage('');
        } else {
          setMessage('No drivers found.');
        }
      } catch (error) {
        setMessage(error.message || 'Failed to fetch drivers.');
      }
    };

    fetchDriverData();
  }, [supplierId, token]);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const carsResponse = await getAllCars(supplierId, token);
        console.log('Raw Cars API Data:', carsResponse);

        const formattedCars = (carsResponse || []).map((car) => {
          const rawName = car.name || car.car_name || car.vehicle_name || 'Unknown';
          return {
            label: rawName.replace(/_/g, ' '),
            value: car.car_id,
          };
        });

        setVehicleTypes(formattedCars);
      } catch (error) {
        console.error('Error fetching cars:', error);
      }
    };

    fetchCars();
  }, [token, supplierId]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow only digits for country_code field
    const newValue = name === "country_code"
      ? value.replace(/\D/g, "") // remove non-numeric characters
      : value;

    setFormData((prev) => ({
      ...prev,
      [name]: newValue,      
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loginAccess && !quotationProcess && !assignJourneyProcess) {
      setError("Please select at least one process (Quotation or Assign Journey)");
      return;
    }
    setError("");
    const required = ['email', 'first_name', 'last_name', 'mobile_number', 'vehicle', 'car_reg', 'make'];
    const missing = required.find((f) => !formData[f]);
    if (missing) return alert(`Please fill in ${missing.replace('_', ' ')}`);

    setActionLoading(true);

    try {
      const submitData = {
        ...formData,
        login_access: loginAccess ? 1 : 0,
        quotation_process: quotationProcess ? 1 : 0,
        assign_journey_process: assignJourneyProcess ? 1 : 0,
      };

      if (isEditing && editDriverId) {
        submitData.driver_id = editDriverId;
        console.log("Submitting to save_supplier_driver:", submitData);
        await save_supplier_driver(submitData, token);
        alert('Driver updated successfully!');
      } else {
        // Add new driver
        await add_driver(submitData, token);
        alert('Driver added successfully!');
      }

      setModalOpen(false);
      window.location.reload();
    } catch (error) {
      alert(error.message || 'Something went wrong');
    } finally {
      setActionLoading(false);
    }
  };


  const handleEditClick = async (driverId) => {
    try {
      setAgreed(true);
      const response = await get_supplier_details(driverId, token);

      const driverData = response?.driver;
      const perms = response?.subs_permissions || {};

      if (driverData) {
        setFormData({
          supplier_id: driverData.supplier_id || '',
          email: driverData.email || '',
          first_name: driverData.firstname || '',
          last_name: driverData.lastname || '',
          country_code: driverData.code1 || '',
          mobile_number: driverData.mob || '',
          vehicle: driverData.vehicle || '',
          car_reg: driverData.car_reg || '',
          make: driverData.make || '',
          vehicle_colour: driverData.v_color || '',
          member_type: driverData.customer_type || 'subs',
        });

        // Set checkbox states from subs_permissions table
        setLoginAccess(!!Number(perms.login_access));
        setQuotationProcess(!!Number(perms.quotation_process));
        setAssignJourneyProcess(!!Number(perms.assign_journeys_process));

        setEditDriverId(driverId);
        setIsEditing(true);
        setIsEditMode(true);
        setModalOpen(true);
      } else {
        alert('Driver not found');
      }
    } catch (error) {
      console.error('Edit fetch error:', error);
      alert(error.message || 'Failed to fetch driver');
    }
  };

  const handleDeleteClick = async (driverId) => {
    if (!window.confirm('Are you sure you want to delete this driver?')) return;

    try {
      await delete_driver(driverId, token);
      alert('Driver deleted successfully!');
      window.location.reload();
    } catch (error) {
      alert(error.message || 'Failed to delete driver');
    }
  };
  const handleLoginAccess = (checked) => {
    setLoginAccess(checked);

    if (!checked) {
      // reset processes if login access is unchecked
      setQuotationProcess(false);
      setAssignJourneyProcess(false);
      setError("");
    }
  };
  return (
    <>
      <Header />

      <div className="max-w-7xl mx-auto p-6">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-gray-800">Driver List</h1>
          <button
            onClick={() => {
              setFormData({
                supplier_id: supplierId || '',
                email: '',
                first_name: '',
                last_name: '',
                country_code: '44',
                mobile_number: '0',
                vehicle: '',
                car_reg: '',
                make: '',
                vehicle_colour: '',
                member_type: 'subs',
              });
              setIsEditing(false);
              setEditDriverId(null);
              setIsEditMode(false);
              setModalOpen(true);
              setAgreed(false);
              setLoginAccess(false);
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded shadow"
          >
            <i className="fas fa-plus mr-2"></i> Add Driver
          </button>
        </div>

        {message ? (
          <p className="text-gray-600 text-center">{message}</p>
        ) : (
          <div className="overflow-x-auto bg-white rounded shadow">
            <div className="p-4 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search drivers by name or email"
                className="flex-1 px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />

              <button
                onClick={() => setSearchTerm('')}
                className="px-4 py-2 bg-gray-100 text-gray-700 border border-gray-300 rounded hover:bg-red-100 hover:text-red-600 transition text-sm"
              >
                Clear
              </button>

            </div>

            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-6 py-3">#</th>
                  <th className="px-6 py-3">Driver Name</th>
                  <th className="px-6 py-3">Email</th>
                  <th className="px-6 py-3 text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {supplierDrivers
                  .filter(driver =>
                    driver.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    driver.email?.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((driver, index) => (
                    <tr key={index}>
                      <td className="px-6 py-3">{index + 1}</td>
                      <td className="px-6 py-3">{driver.name}</td>
                      <td className="px-6 py-3">{driver.email}</td>
                      <td className="px-6 py-3 text-center space-x-3">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            handleEditClick(driver.driver_id);
                          }}
                          className="text-indigo-600 hover:text-indigo-900"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            handleDeleteClick(driver.driver_id);
                          }}
                          className="text-red-600 hover:text-red-900"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 relative">
            <button
              onClick={() => {
                setModalOpen(false);
                setIsEditing(false);
                setEditDriverId(null);
                setIsEditMode(false);
              }}
              className="absolute top-2 right-3 text-gray-500 hover:text-red-600 text-xl"
            >
              &times;
            </button>

            <h2 className="text-xl font-semibold mb-4 text-center">
              {isEditing ? 'Edit Driver' : 'Add Driver'}
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Member Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Member Type</label>
                <div className="flex items-center space-x-3">
                  <label className="flex items-center space-x-2">
                    <input
                      type="radio"
                      name="member_type"
                      value="subs"
                      checked={formData.member_type === 'subs'}
                      onChange={handleChange}
                      readOnly
                    />
                    <span>Subs</span>
                  </label>
                </div>
              </div>
                <div className="flex items-center gap-4">
                  <input
                    id="login-access"
                    type="checkbox"
                    checked={loginAccess}
                    onChange={(e) => handleLoginAccess(e.target.checked)}
                    className="w-4 h-4 text-blue-600 border-gray-300 rounded-sm"
                  />
                  <label htmlFor="login-access" className="text-sm font-medium text-gray-700">
                    Login Access
                  </label>

                  {loginAccess && (
                    <>
                      <input
                        id="quotation-process"
                        type="checkbox"
                        checked={quotationProcess}
                        onChange={(e) => setQuotationProcess(e.target.checked)}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded-sm"
                      />
                      <label htmlFor="quotation-process" className="text-sm font-medium text-gray-700">
                        Quotation process
                      </label>

                      <input
                        id="assign-journey-process"
                        type="checkbox"
                        checked={assignJourneyProcess}
                        onChange={(e) => setAssignJourneyProcess(e.target.checked)}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded-sm"
                      />
                      <label
                        htmlFor="assign-journey-process"
                        className="text-sm font-medium text-gray-700"
                      >
                        Assign Journey process
                      </label>
                    </>
                  )}
                </div>

                {error && <p className="text-red-500 text-sm">{error}</p>}
                {/* Name and Contact */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="first_name" className="block text-sm font-medium text-gray-700 mb-1">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="first_name"
                      name="first_name"
                      placeholder="First Name"
                      value={formData.first_name}
                      onChange={handleChange}
                      className="border px-3 py-2 rounded w-full"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="last_name" className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="last_name"
                      name="last_name"
                      placeholder="Last Name"
                      value={formData.last_name}
                      onChange={handleChange}
                      className="border px-3 py-2 rounded w-full"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="border px-3 py-2 rounded w-full"
                      required
                      disabled={isEditMode}
                    />
                  </div>

                  <div className="flex space-x-2">
                    {/* Country Code Field */}
                    <div className="w-28">
                      <label htmlFor="country_code" className="block text-sm font-medium text-gray-700 mb-1">
                        Code
                      </label>
                      <div className="flex items-center border rounded px-2 py-2 bg-white">
                        {/* + symbol box */}
                        <span className="text-gray-700 text-sm font-semibold mr-1">+</span>

                        {/* actual input field for country code */}
                        <input
                          type="text"
                          id="country_code"
                          name="country_code"
                          placeholder="44"
                          value={formData.country_code}
                          onChange={handleChange}
                          pattern="[0-9]{1,4}"
                          maxLength={4}
                          title="Enter a valid country code"
                          className="w-full border-none focus:ring-0 focus:outline-none text-sm"
                          required
                        />
                      </div>
                    </div>


                    {/* Mobile Number Field */}
                    <div className="flex-1">
                      <label htmlFor="mobile_number" className="block text-sm font-medium text-gray-700 mb-1">
                        Mobile Number <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="tel"
                        id="mobile_number"
                        name="mobile_number"
                        placeholder="Mobile Number"
                        value={formData.mobile_number}
                        onChange={handleChange}
                        className="border px-3 py-2 rounded w-full"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Vehicle Type */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-wrap gap-4">
                    {vehicleTypes.map((v) => (
                      <label key={v.value} className="flex items-center space-x-2">
                        <input
                          type="radio"
                          name="vehicle"
                          value={v.value}
                          checked={formData.vehicle === v.value}
                          onChange={handleChange}
                        />
                        <span>{v.label}</span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Car Info */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label htmlFor="car_reg" className="block text-sm font-medium text-gray-700 mb-1">
                      Car Registration <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="car_reg"
                      name="car_reg"
                      placeholder="Car Registration"
                      value={formData.car_reg}
                      onChange={handleChange}
                      className="border px-3 py-2 rounded w-full"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="make" className="block text-sm font-medium text-gray-700 mb-1">
                      Make <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="make"
                      name="make"
                      placeholder="Make and Model"
                      value={formData.make}
                      onChange={handleChange}
                      className="border px-3 py-2 rounded w-full"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="vehicle_colour" className="block text-sm font-medium text-gray-700 mb-1">
                      Vehicle Colour
                    </label>
                    <input
                      type="text"
                      id="vehicle_colour"
                      name="vehicle_colour"
                      placeholder="Vehicle Colour"
                      value={formData.vehicle_colour}
                      onChange={handleChange}
                      className="border px-3 py-2 rounded w-full"
                    />
                  </div>
                </div>
                <div class="flex items-center">
                  <input id="link-checkbox" type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                  <label for="link-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-500">I agree with the <a href="https://jat-uk.com/instructions-and-terms" class="text-blue-600 dark:text-blue-500 hover:underline">terms and conditions</a>.</label>
                </div>
                <button
                  type="submit"
                  className={`w-full text-white py-2 rounded transition ${agreed ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400 cursor-not-allowed'
                    }`}
                  disabled={!agreed}
                >
                  {actionLoading ? (isEditing ? 'Updating...' : 'Adding...') : isEditing ? 'Update Driver' : 'Add Driver'}
                </button>
            </form>

          </div>
        </div>
      )}
    </>
  );
};

export default DriverList;
